import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue';
import { contract, ticket, newspaper, person, navigate } from 'ionicons/icons';
import { Device } from '@capacitor/device';
import { estControleur } from '@/services/tickets.service';
import { ref, onMounted, onBeforeMount } from 'vue';
import { useCounterStore } from '@/store';
import SessionExpiryIndicator from '@/components/divers/SessionExpiryIndicator.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'TabsPage',
  setup(__props) {

const store = useCounterStore()

const classTabBar = ref('iontabar');

onBeforeMount(() => {
  //console.log("aller controller si controleur");
});

onMounted(async () => {
  const info = await Device.getInfo();
  const modelsChin = [
    "iPad Pro (12.9-inch) (2nd generation)",
    "iPad Pro (12.9-inch)",
    "iPad (9th generation)",
    "iPad (8th generation)",
    "iPad (7th generation)",
    "iPad (6th generation)",
    "iPad (5th generation)",
    "iPad Air (3rd generation)",
    "iPad Air (2nd generation)",
    "iPad Air",
    "iPad mini (5th generation)",
    "iPad mini 4",
    "iPhone 8 Plus",
    "iPhone 8",
    "iPhone SE (3rd generation)",
    "iPhone SE (2nd generation)",
    "iPhone SE",
  ]
  if (info.name !== undefined) {
    if (modelsChin.includes(info.name?.toString())) {
      //console.log('Device has chin');
      classTabBar.value = 'iontabar iontabarchin';
    } else {
      //console.log('Device has no chin');
      classTabBar.value = 'iontabar';
    }
  } else {
    //console.log("Device is not a mobile device")
  }

});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonTabs), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet)),
          (_unref(estControleur))
            ? (_openBlock(), _createBlock(_unref(IonTabBar), {
                key: 0,
                class: _normalizeClass(classTabBar.value),
                translucent: true,
                slot: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTabButton), {
                    tab: "accueil",
                    href: "/tabs/accueil"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(newspaper)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Accueil")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "audits",
                    href: "/tabs/audits"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(ticket)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Audits")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "carto",
                    href: "/tabs/carto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(navigate)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Carto.")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "ncf",
                    href: "/tabs/ncf"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(contract)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("NCF")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "profile",
                    href: "/tabs/profile"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(person)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Profil")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"]))
            : (_openBlock(), _createBlock(_unref(IonTabBar), {
                key: 1,
                class: _normalizeClass(classTabBar.value),
                translucent: true,
                slot: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTabButton), {
                    tab: "accueil",
                    href: "/tabs/accueil",
                    class: "acceuilRosalyna",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).activeTab = 'ACC'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(newspaper)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Accueil")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "tickets",
                    href: "/tabs/tickets",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).activeTab = 'TIC'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(ticket)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Tickets")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "carto",
                    href: "/tabs/carto",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).activeTab = 'CAR'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(navigate)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Carto.")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "search",
                    href: "/tabs/search",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).activeTab = 'REC'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(contract)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Recher.")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTabButton), {
                    tab: "profile",
                    href: "/tabs/profile",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(store).activeTab = 'PRO'))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        "aria-hidden": "true",
                        icon: _unref(person)
                      }, null, 8, ["icon"]),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode("Profil")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"])),
          _createVNode(SessionExpiryIndicator)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})